<template>
	<div class="app-date-range-picker-layout d-flex flex-column">
		<div
			v-if="showHeader"
			class="date-range-header d-flex justify-space-evenly align-center"
		>
			<slot name="date-from" />
			<span class="split px-1">:</span>
			<slot name="time-from" />
			<span class="split px-2"> - </span>
			<slot name="date-to" />
			<span class="split px-1">:</span>
			<slot name="time-to" />
			<slot name="settings" />
		</div>
		<div class="date-range-content d-flex justify-space-evenly">
			<div
				v-if="showRangesList"
				class="ranges"
				:style="calendarHeight ? `height: ${calendarHeight}px` : ''"
			>
				<slot name="ranges" />
			</div>
			<div class="calendar">
				<slot name="calendar" />
			</div>
		</div>
		<div class="date-range-footer pt-2">
			<slot name="footer" />
		</div>
	</div>
</template>

<script setup>

defineProps({
	calendarHeight: {
		type: Number,
		default: null,
	},

	showHeader: {
		type: Boolean,
		default: true,
	},

	showRangesList: {
		type: Boolean,
		default: false,
	},
})

</script>

<style lang="scss">
.app-date-range-picker-layout {

	.date-range-header {
		border-bottom: 1px solid #ddd;
		padding: 0.5rem 0;
	}

	.ranges {
		border-right: 1px solid #ddd;
		overflow-y: auto;
	}

}
</style>
